import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Modal } from './Modal'
import { cn } from '@/utils/cn'

interface ConfirmModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title?: string
  message?: string
  confirmLabel?: string
  variant?: 'danger' | 'primary'
  isLoading?: boolean
}

export function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  variant = 'danger',
  isLoading = false,
}: ConfirmModalProps) {
  const { t } = useTranslation('common')

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      disableBackdropClose={isLoading}
      footer={
        <>
          <button
            onClick={onClose}
            disabled={isLoading}
            className="btn btn-secondary"
          >
            {t('cancel')}
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className={cn(
              'btn',
              variant === 'danger' ? 'btn-danger' : 'btn-primary'
            )}
          >
            {isLoading ? t('deleting') : (confirmLabel ?? t('confirm'))}
          </button>
        </>
      }
    >
      <div className="flex items-start gap-4 py-1">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-danger/10 ring-4 ring-danger/5">
          <AlertTriangle className="h-5 w-5 text-danger" />
        </div>
        <div className="min-w-0">
          <h3 className="font-semibold text-muted-fg">
            {title ?? t('confirmDeleteTitle', { name: '' })}
          </h3>
          <p className="mt-1 text-sm text-muted leading-relaxed">
            {message ?? t('confirmDeleteMessage')}
          </p>
        </div>
      </div>
    </Modal>
  )
}
